import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _DEFAULT_LOCALE_FOR_L, _localeTldMap, _localeDisplayNameMap, _localeDisplayNameWit, _ISOLangMap;

// eslint-disable-next-line no-restricted-imports
import { TLD } from '@peloton/app-config';
import { toCountry } from './country';
import { Language, toLanguage } from './language';
export var Locale; // Types of locales for languages for class content may differ from Locale,
// which was introduced when display and content languages were assumed to be the same.

(function (Locale) {
  Locale["EnglishUnitedStates"] = "en-US";
  Locale["EnglishAustralia"] = "en-AU";
  Locale["EnglishUnitedKingdom"] = "en-GB";
  Locale["EnglishCanada"] = "en-CA";
  Locale["GermanGermany"] = "de-DE";
  Locale["Default"] = "en-US";
  Locale["EnglishBeta"] = "uz-UZ";
  Locale["SpanishMexico"] = "es-MX";
  Locale["FrenchCanada"] = "fr-CA";
})(Locale || (Locale = {}));

export var ContentLocale;

(function (ContentLocale) {
  ContentLocale["EnglishUnitedStates"] = "en-US";
  ContentLocale["EnglishAustralia"] = "en-AU";
  ContentLocale["EnglishUnitedKingdom"] = "en-GB";
  ContentLocale["EnglishCanada"] = "en-CA";
  ContentLocale["GermanGermany"] = "de-DE";
  ContentLocale["SpanishSpain"] = "es-ES";
  ContentLocale["EnglishBeta"] = "uz-UZ";
  ContentLocale["SpanishMexico"] = "es-MX";
  ContentLocale["FrenchCanada"] = "fr-CA";
})(ContentLocale || (ContentLocale = {}));

var requiresMarketingOptIn = [Locale.EnglishUnitedKingdom, Locale.EnglishCanada, Locale.EnglishAustralia];
export var toAllowMarketing = function toAllowMarketing(locale) {
  return !requiresMarketingOptIn.includes(locale);
};
export var DEFAULT_LOCALE_FOR_LANGUAGE = (_DEFAULT_LOCALE_FOR_L = {}, _defineProperty(_DEFAULT_LOCALE_FOR_L, Language.English, Locale.EnglishUnitedStates), _defineProperty(_DEFAULT_LOCALE_FOR_L, Language.German, Locale.GermanGermany), _defineProperty(_DEFAULT_LOCALE_FOR_L, Language.Spanish, Locale.SpanishMexico), _defineProperty(_DEFAULT_LOCALE_FOR_L, Language.French, Locale.FrenchCanada), _DEFAULT_LOCALE_FOR_L);
export var SupportedTLD;

(function (SupportedTLD) {
  SupportedTLD["Au"] = ".com.au";
  SupportedTLD["Com"] = ".com";
  SupportedTLD["CoUk"] = ".co.uk";
  SupportedTLD["Ca"] = ".ca";
  SupportedTLD["De"] = ".de";
})(SupportedTLD || (SupportedTLD = {}));

export var localeTldMap = (_localeTldMap = {}, _defineProperty(_localeTldMap, Locale.EnglishBeta, SupportedTLD.Com), _defineProperty(_localeTldMap, Locale.EnglishUnitedStates, SupportedTLD.Com), _defineProperty(_localeTldMap, Locale.EnglishUnitedKingdom, SupportedTLD.CoUk), _defineProperty(_localeTldMap, Locale.EnglishCanada, SupportedTLD.Ca), _defineProperty(_localeTldMap, Locale.GermanGermany, SupportedTLD.De), _defineProperty(_localeTldMap, Locale.EnglishAustralia, SupportedTLD.Au), _defineProperty(_localeTldMap, Locale.SpanishMexico, SupportedTLD.Com), _defineProperty(_localeTldMap, Locale.FrenchCanada, SupportedTLD.Ca), _localeTldMap);

var getSupportedTldsRegex = function getSupportedTldsRegex() {
  var supportedTlds = Object.values(SupportedTLD);
  var escapedTlds = supportedTlds.map(function (tld) {
    return tld.replace(/\./g, '\\.');
  });
  return new RegExp("".concat(escapedTlds.join('|'), "$"));
};

var supportedTldsRegex = getSupportedTldsRegex();
var localeDisplayNameMap = (_localeDisplayNameMap = {}, _defineProperty(_localeDisplayNameMap, Locale.EnglishCanada, 'Canada'), _defineProperty(_localeDisplayNameMap, Locale.EnglishUnitedKingdom, 'United Kingdom'), _defineProperty(_localeDisplayNameMap, Locale.EnglishUnitedStates, 'United States'), _defineProperty(_localeDisplayNameMap, Locale.EnglishAustralia, 'Australia'), _defineProperty(_localeDisplayNameMap, Locale.GermanGermany, 'Deutschland'), _defineProperty(_localeDisplayNameMap, Locale.SpanishMexico, 'Mexico'), _defineProperty(_localeDisplayNameMap, Locale.EnglishBeta, 'English - beta'), _defineProperty(_localeDisplayNameMap, Locale.FrenchCanada, 'French Canada'), _localeDisplayNameMap);
var localeDisplayNameWithArticleMap = (_localeDisplayNameWit = {}, _defineProperty(_localeDisplayNameWit, Locale.EnglishCanada, 'Canada'), _defineProperty(_localeDisplayNameWit, Locale.EnglishUnitedKingdom, 'the United Kingdom'), _defineProperty(_localeDisplayNameWit, Locale.EnglishUnitedStates, 'the United States'), _defineProperty(_localeDisplayNameWit, Locale.EnglishAustralia, 'Australia'), _defineProperty(_localeDisplayNameWit, Locale.GermanGermany, 'Germany'), _defineProperty(_localeDisplayNameWit, Locale.SpanishMexico, 'Mexico'), _defineProperty(_localeDisplayNameWit, Locale.EnglishBeta, 'English - beta'), _defineProperty(_localeDisplayNameWit, Locale.FrenchCanada, 'French Canada'), _localeDisplayNameWit); //Per w3c recommendation (https://www.w3.org/International/questions/qa-choosing-language-tags#langsubtag), start adding region subtags when we use the same language in more than one locale.

var ISOLangMap = (_ISOLangMap = {}, _defineProperty(_ISOLangMap, Locale.EnglishCanada, 'en-CA'), _defineProperty(_ISOLangMap, Locale.EnglishUnitedKingdom, 'en-GB'), _defineProperty(_ISOLangMap, Locale.EnglishUnitedStates, 'en-US'), _defineProperty(_ISOLangMap, Locale.EnglishAustralia, 'en-AU'), _defineProperty(_ISOLangMap, Locale.GermanGermany, 'de'), _defineProperty(_ISOLangMap, Locale.SpanishMexico, 'es'), _defineProperty(_ISOLangMap, Locale.EnglishBeta, 'uz'), _defineProperty(_ISOLangMap, Locale.FrenchCanada, 'fr-CA'), _ISOLangMap);
export var toMatchingTld = function toMatchingTld(hostname) {
  var match = hostname.match(supportedTldsRegex);
  return match ? match[0] : SupportedTLD.Com;
};
export var toLocale = function toLocale() {
  var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : toLanguage();
  var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : toCountry();
  var locale = "".concat(language, "-").concat(country.toUpperCase());
  return toLocaleFromString(locale, language);
};
/**
 * This will return Locale based on App Config provided TLD, if available.
 * Falls back to `window.location.hostname`, if not.
 */

export var toLocaleFromHostname = function toLocaleFromHostname() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TLD !== null && TLD !== void 0 ? TLD : window.location.hostname;
  var value = Locale.Default;

  var assignLocaleValue = function assignLocaleValue(_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        locale = _ref2[0],
        tld = _ref2[1];

    if (hostname.endsWith(tld) && locale != Locale.EnglishBeta && locale !== Locale.SpanishMexico && locale !== Locale.FrenchCanada) {
      value = locale;
    }
  }; // NextJS requires named functions to be used in components


  Object.entries(localeTldMap).forEach(assignLocaleValue);
  return value;
};
export var toLocaleFromTLD = toLocaleFromHostname; // TODO: remove dependency on window.location

export var toLocaleOrigin = function toLocaleOrigin(locale) {
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location;
  var currentTld = localeTldMap[toLocaleFromHostname(location.hostname)];
  var toTld = localeTldMap[locale];

  if (locale === Locale.EnglishAustralia) {
    toTld = '.com.au';
  }

  var hostname = location.hostname.replace(currentTld, toTld);
  var port = location.port ? ":".concat(location.port) : ''; // launch day hack to handle corporate wellness redirects so we don't lose leads
  // TODO: platform fix for handling pathname redirects globally

  var pathname = '';

  if (location.pathname === '/corporate-wellness' && (locale === Locale.EnglishUnitedStates || locale === Locale.EnglishCanada || locale === Locale.EnglishUnitedKingdom)) {
    pathname = "".concat(location.pathname).concat(location.search);
  } // launch day hack to handle guide announcement redirects so we don't lose leads
  // TODO: platform fix for handling pathname redirects globally


  if (location.pathname === '/guide-announce' && (locale === Locale.EnglishUnitedStates || locale === Locale.EnglishCanada || locale === Locale.EnglishUnitedKingdom || locale === Locale.EnglishAustralia)) {
    pathname = "".concat(location.pathname).concat(location.search);
  }

  return "".concat(location.protocol, "//").concat(hostname).concat(port).concat(pathname);
};
export var toLocaleHostname = function toLocaleHostname(locale) {
  var _localeTldMap$locale;

  return "onepeloton".concat((_localeTldMap$locale = localeTldMap[locale]) !== null && _localeTldMap$locale !== void 0 ? _localeTldMap$locale : localeTldMap[Locale.Default]);
};
export var toDisplayName = function toDisplayName(locale) {
  return localeDisplayNameMap[locale];
};
export var toDisplayNameWithArticle = function toDisplayNameWithArticle(locale) {
  return localeDisplayNameWithArticleMap[locale];
};
export var toISOLang = function toISOLang(locale) {
  return ISOLangMap[locale];
};
export var toLocaleFromString = function toLocaleFromString(locale, language) {
  var key;

  if (locale) {
    key = Object.keys(Locale).find(function (k) {
      return Locale[k].toLowerCase() === locale.toLowerCase();
    });
  }

  return key ? Locale[key] : DEFAULT_LOCALE_FOR_LANGUAGE[language] || Locale.Default;
};
export var toLocaleFromCountry = function toLocaleFromCountry(country) {
  var locales = {
    gb: Locale.EnglishUnitedKingdom,
    de: Locale.GermanGermany,
    au: Locale.EnglishAustralia,
    us: Locale.EnglishUnitedStates,
    ca: Locale.EnglishCanada
  };
  return locales[country];
};
export var isLocale = function isLocale(str) {
  return Object.values(Locale).includes(str);
};